module.exports = __webpack_public_path__ + "img/saved.78731898.svg";